import { useRef } from "react";
import WealthEmpireMock from "../components/WealthEmpireMock.js";
import FloatingBlock from "../components/FloatingBlock";
import FeatureCard from "../components/FeatureCard";

const WealthEmpirePage = ({ navigate }) => {
  const featuresRef = useRef(null);

  const CoinBlock = ({ style, delay }) => (
    <div style={{
      position: "absolute",
      width: 44, height: 44,
      borderRadius: "50%",
      background: "linear-gradient(135deg, #FFD700, #FFA502)",
      boxShadow: "0 0 18px #FFD70088, 0 4px 12px #0008",
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: 22,
      animation: "floatBlock 6s ease-in-out infinite",
      animationDelay: `${delay}s`,
      ...style,
    }}>💰</div>
  );

  return (
    <main>
      {/* HERO */}
      <section style={{ minHeight: "100vh", display: "flex", alignItems: "center", position: "relative", overflow: "hidden", padding: "100px 5% 60px" }}>
        {[
          { color: "#FFD70030", left: "-10%", top: "10%", size: 500 },
          { color: "#FFA50225", right: "-5%", top: "30%", size: 400 },
          { color: "#FF475720", left: "40%", bottom: "5%", size: 350 },
          { color: "#2ED57318", left: "20%", top: "50%", size: 300 },
        ].map((b, i) => (
          <div key={i} style={{ position: "absolute", width: b.size, height: b.size, borderRadius: "50%", background: b.color, filter: "blur(80px)", left: b.left, right: b.right, top: b.top, bottom: b.bottom, animation: `blobFloat ${7 + i}s ease-in-out infinite`, animationDelay: `${i * 1.5}s`, pointerEvents: "none" }} />
        ))}

        <CoinBlock style={{ left: "5%", top: "22%" }} delay={0} />
        <CoinBlock style={{ left: "9%", top: "68%" }} delay={1.2} />
        <CoinBlock style={{ right: "7%", top: "18%" }} delay={0.6} />
        <CoinBlock style={{ right: "13%", bottom: "22%" }} delay={1.8} />
        <FloatingBlock color="#2ED573" style={{ left: "20%", bottom: "12%" }} delay={2.2} />

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", maxWidth: 1200, margin: "0 auto", gap: 60, flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 300, animation: "fadeUp 0.8s ease both" }}>
            <div style={{ marginBottom: 16 }}>
              <span style={{ fontSize: 12, cursor: "pointer", color: "rgba(255,255,255,0.4)", fontWeight: 700 }} onClick={() => navigate("/games")}>← All Games</span>
            </div>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,215,0,0.12)", border: "1px solid rgba(255,215,0,0.3)", borderRadius: 50, padding: "6px 18px", marginBottom: 24, fontSize: 13, fontWeight: 700, color: "#FFD700" }}>
              💰 Now on Google Play Store
            </div>
            <h1 style={{ fontFamily: "'Fredoka One', cursive", fontSize: "clamp(44px, 6vw, 76px)", lineHeight: 1.05, marginBottom: 24 }}>
              <span style={{ background: "linear-gradient(135deg, #fff 30%, rgba(255,255,255,0.7))", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>Build Your</span>
              <br />
              <span style={{ background: "linear-gradient(135deg, #FFD700, #FFA502, #FF4757)", backgroundSize: "200% 200%", animation: "gradientFlow 3s ease infinite", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>Wealth Empire!</span>
            </h1>
            <p style={{ fontSize: 18, color: "rgba(255,255,255,0.65)", lineHeight: 1.7, marginBottom: 36, maxWidth: 480 }}>
              Start with a humble lemonade stand and grow it into a global business empire. Hire managers, automate profits, and become a billionaire tycoon!
            </p>
            <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
              <button className="btn-gold" style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 16 }}
                onClick={() => window.open("https://play.google.com/store", "_blank")}>
                <span style={{ fontSize: 22 }}>▶</span> Download on Play Store
              </button>
              <button className="btn-secondary" onClick={() => featuresRef.current?.scrollIntoView({ behavior: "smooth" })}>
                Learn More ↓
              </button>
            </div>
            <div style={{ display: "flex", gap: 32, marginTop: 48, flexWrap: "wrap" }}>
              {[["⭐","4.7+","Rating"],["📥","5K+","Downloads"],["🏢","50+","Businesses"]].map(([icon,val,label]) => (
                <div key={label}>
                  <div style={{ fontSize: 13, color: "rgba(255,255,255,0.4)", marginBottom: 2 }}>{icon} {label}</div>
                  <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: 28, color: "#FFD700" }}>{val}</div>
                </div>
              ))}
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "center", flex: "0 0 auto", animation: "fadeUp 0.8s ease 0.2s both" }}>
            <div style={{ position: "relative" }}>
              <div style={{ position: "absolute", inset: -30, background: "radial-gradient(ellipse, #FFD70022, transparent 70%)", borderRadius: "50%", animation: "blobFloat 5s ease-in-out infinite" }} />
              <WealthEmpireMock />
            </div>
          </div>
        </div>
      </section>

      {/* HOW TO PLAY */}
      <section style={{ padding: "80px 5%", position: "relative" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", textAlign: "center" }}>
          <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: "clamp(32px, 5vw, 52px)", marginBottom: 16 }}>
            How to <span style={{ color: "#FFD700" }}>Play</span>
          </div>
          <p style={{ color: "rgba(255,255,255,0.5)", marginBottom: 60, fontSize: 16 }}>Build. Automate. Expand. Repeat.</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 24 }}>
            {[
              { n: "01", color: "#FFD700", title: "Start a Business", desc: "Tap to open your first business. Each tap earns you money you can reinvest to grow faster.", icon: "🍋" },
              { n: "02", color: "#FFA502", title: "Hire Managers", desc: "Hire managers to run your businesses automatically while you focus on expanding your empire.", icon: "👔" },
              { n: "03", color: "#2ED573", title: "Expand & Dominate", desc: "Unlock more businesses, upgrade them, and multiply your income until you reach billions!", icon: "🏙️" },
            ].map(({ n, color, title, desc, icon }) => (
              <div key={n} style={{ background: "rgba(255,255,255,0.03)", border: `1px solid ${color}22`, borderRadius: 24, padding: "36px 28px", position: "relative", overflow: "hidden", transition: "transform 0.3s" }}
                onMouseEnter={e => e.currentTarget.style.transform = "translateY(-6px)"}
                onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
              >
                <div style={{ position: "absolute", top: -20, right: -20, fontSize: 100, color, opacity: 0.06, fontFamily: "'Fredoka One', cursive", lineHeight: 1 }}>{n}</div>
                <div style={{ fontSize: 48, marginBottom: 16 }}>{icon}</div>
                <div style={{ color, fontFamily: "'Fredoka One', cursive", fontSize: 11, letterSpacing: 2, marginBottom: 8 }}>STEP {n}</div>
                <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: 22, marginBottom: 12 }}>{title}</div>
                <div style={{ color: "rgba(255,255,255,0.55)", fontSize: 14, lineHeight: 1.75 }}>{desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* BUSINESSES SHOWCASE */}
      <section style={{ padding: "80px 5%", background: "rgba(255,255,255,0.015)" }}>
        <div style={{ maxWidth: 1000, margin: "0 auto", textAlign: "center" }}>
          <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: "clamp(28px,4vw,46px)", marginBottom: 16 }}>
            Your <span style={{ color: "#FFD700" }}>Business Empire</span>
          </div>
          <p style={{ color: "rgba(255,255,255,0.5)", marginBottom: 50, fontSize: 15 }}>From humble beginnings to global domination</p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 16 }}>
            {[
              { icon: "🍋", name: "Lemonade Stand", income: "$0.50/s", color: "#FFD700" },
              { icon: "🍕", name: "Pizza Shop", income: "$3.20/s", color: "#FF4757" },
              { icon: "🚗", name: "Car Wash", income: "$12/s", color: "#3EAEFF" },
              { icon: "🏨", name: "Hotel", income: "$80/s", color: "#A855F7" },
              { icon: "🏦", name: "Bank", income: "$500/s", color: "#2ED573" },
              { icon: "🚀", name: "Space Co.", income: "$10K/s", color: "#FF6B81" },
            ].map(b => (
              <div key={b.name} style={{
                background: `${b.color}10`, border: `1px solid ${b.color}25`,
                borderRadius: 16, padding: "20px 12px", textAlign: "center",
                transition: "transform 0.2s, box-shadow 0.2s",
                cursor: "default",
              }}
                onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = `0 12px 30px ${b.color}33`; }}
                onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = ""; }}
              >
                <div style={{ fontSize: 36, marginBottom: 8 }}>{b.icon}</div>
                <div style={{ fontWeight: 700, fontSize: 12, color: "#fff", marginBottom: 4 }}>{b.name}</div>
                <div style={{ fontSize: 11, color: b.color, fontWeight: 700 }}>{b.income}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section ref={featuresRef} id="features" style={{ padding: "80px 5%" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 60 }}>
            <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: "clamp(32px, 5vw, 52px)", marginBottom: 16 }}>
              Why <span style={{ color: "#FFD700" }}>Wealth Empire?</span>
            </div>
            <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 16 }}>An idle tycoon built for everyone</p>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 20 }}>
            {[
              { icon: "💸", title: "Idle Income", desc: "Earn money even when you're not playing. Hire managers and let your empire run on autopilot.", color: "#FFD700" },
              { icon: "📈", title: "Progression System", desc: "Unlock new businesses, upgrade existing ones, and watch your income multiply exponentially.", color: "#FFA502" },
              { icon: "🏆", title: "Prestige & Rebirth", desc: "Reset your empire for powerful multipliers. Each prestige makes your next run faster and stronger.", color: "#A855F7" },
              { icon: "🎯", title: "Daily Missions", desc: "Complete daily goals to earn bonus rewards and keep your empire growing even faster.", color: "#2ED573" },
              { icon: "📵", title: "Offline Earnings", desc: "Your businesses keep earning while you sleep. Come back to a pile of cash every morning!", color: "#3EAEFF" },
              { icon: "🎨", title: "Stunning UI", desc: "Beautiful gold and dark theme with satisfying animations that make every dollar feel rewarding.", color: "#FF4757" },
            ].map(f => <FeatureCard key={f.title} {...f} />)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ padding: "80px 5%", textAlign: "center", position: "relative", overflow: "hidden" }}>
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg, #FFD70012, #FFA50212, #FF475712, #2ED57312)", backgroundSize: "400% 400%", animation: "gradientFlow 8s ease infinite" }} />
        <div style={{ position: "relative", maxWidth: 640, margin: "0 auto" }}>
          <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: "clamp(32px,5vw,56px)", marginBottom: 20, lineHeight: 1.1 }}>
            Start Your <span style={{ color: "#FFD700" }}>Empire</span> Today!
          </div>
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 17, marginBottom: 40, lineHeight: 1.7 }}>
            Download Wealth Empire: Idle Tycoon for free and begin your journey from zero to billions!
          </p>
          <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
            <button className="btn-gold" style={{ fontSize: 18, padding: "18px 44px", display: "flex", alignItems: "center", gap: 12 }}
              onClick={() => window.open("https://play.google.com/store", "_blank")}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><path d="M3.18 23.76a2 2 0 01-1.18-1.8V2.04A2 2 0 013.18.28l11.7 11.74zm15.3-8.64L4.92 22.44l8.6-8.62zm2.46-4.1a2 2 0 010 1.96l-2.7 1.54-3-3 3-3zM4.92 1.56L18.48 8.98l-2.96 2.96z"/></svg>
              Get it on Google Play
            </button>
            <button className="btn-secondary" onClick={() => navigate("/games")}>← All Games</button>
          </div>
          <div style={{ marginTop: 30, color: "rgba(255,255,255,0.3)", fontSize: 13 }}>Free to download · Offline earnings · No pay-to-win</div>
        </div>
      </section>
    </main>
  );
};

export default WealthEmpirePage;